// src/components/car/InteriorVideoPlayer.jsx - COMPLETE FIX
import React, { useState, useRef, useEffect } from "react";
import "../../styles/InteriorVideoPlayer.css";

const InteriorVideoPlayer = ({ videoUrl, poster }) => {
  const [play, setPlay] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const videoRef = useRef(null);

  console.log("🎥 InteriorVideoPlayer Props:", { videoUrl, poster });

  useEffect(() => {
    // Reset states when videoUrl changes
    setPlay(false);
    setError(null);
    setLoading(false);
  }, [videoUrl]);

  if (!videoUrl) {
    console.log("❌ No video URL provided to InteriorVideoPlayer");
    return (
      <div className="interior-video-wrapper">
        <div className="no-video-message">
          <p>Interior video not available</p>
        </div>
      </div>
    );
  }

  // ✅ CRITICAL FIX: Properly construct the full video URL
  const fullVideoUrl = videoUrl.startsWith("http") 
    ? videoUrl 
    : `http://localhost:3001${videoUrl}`;

  console.log("🎬 Full Video URL constructed:", fullVideoUrl);

  // ✅ IMPROVED: Better error handler
  const handleVideoError = (e) => {
    console.error("❌ Video Error Event:", e);
    
    const videoElement = e.target;
    const mediaError = videoElement?.error;
    
    console.error("❌ Video Element:", videoElement);
    console.error("❌ MediaError Object:", mediaError);
    console.error("❌ Network State:", videoElement?.networkState);
    console.error("❌ Ready State:", videoElement?.readyState);
    console.error("❌ Current Source:", videoElement?.currentSrc);
    
    let errorMessage = "Video playback failed";
    
    if (!mediaError) {
      // No error object means likely a loading issue
      errorMessage = "Unable to load video. Please check if the file exists.";
    } else {
      switch(mediaError.code) {
        case 1: // MEDIA_ERR_ABORTED
          errorMessage = "Video loading was aborted";
          break;
        case 2: // MEDIA_ERR_NETWORK
          errorMessage = "Network error while loading video. Check your connection.";
          break;
        case 3: // MEDIA_ERR_DECODE
          errorMessage = "Video file is corrupted or in unsupported format";
          break;
        case 4: // MEDIA_ERR_SRC_NOT_SUPPORTED
          errorMessage = "Video format not supported. Try converting to MP4 (H.264)";
          break;
        default:
          errorMessage = `Video error (code: ${mediaError.code})`;
      }
    }
    
    setError(errorMessage);
    setLoading(false);
    console.error("❌ Error Message:", errorMessage);
  };

  const handleVideoLoad = () => {
    console.log("✅ Video metadata loaded successfully");
    setError(null);
    setLoading(false);
  };

  const handleLoadStart = () => {
    console.log("⏳ Video loading started...");
    setLoading(true);
    setError(null);
  };

  const handleCanPlay = () => {
    console.log("✅ Video can play");
    setLoading(false);
  };

  const handleWaiting = () => {
    console.log("⏳ Video buffering...");
    setLoading(true);
  };

  const handlePlaying = () => {
    console.log("▶️ Video is playing");
    setLoading(false);
  };

  if (error) {
    return (
      <div className="interior-video-wrapper">
        <div className="video-error">
          <div className="video-error-icon">⚠️</div>
          <div className="video-error-message">{error}</div>
          <div className="video-error-details">
            <small>Video URL: {fullVideoUrl}</small>
          </div>
          <button 
            onClick={() => {
              setError(null);
              setPlay(false);
              setLoading(false);
            }}
            className="video-retry-btn"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="interior-video-wrapper interior-with-video">
      {!play ? (
        // Poster/Thumbnail view
        <div 
          className="video-poster" 
          onClick={() => {
            console.log("▶️ Play button clicked");
            setPlay(true);
          }}
        >
          {poster ? (
            <img
              src={poster}
              alt="Interior preview"
              className="video-poster-img"
            />
          ) : (
            <div className="no-poster">
              <div className="no-poster-icon">🎥</div>
              <p>Click to play interior video</p>
            </div>
          )}
          <div className="play-button-overlay">
            <div className="play-icon">▶</div>
          </div>
          <p className="video-label">Interior Video Walkthrough</p>
        </div>
      ) : (
        <>
          {loading && (
            <div className="video-loading">
              <div className="video-spinner"></div>
              <p>Loading video...</p>
            </div>
          )}
          
          {/* ✅ CRITICAL: Added key prop to force re-render on URL change */}
          <video
            key={fullVideoUrl}
            ref={videoRef}
            controls
            autoPlay
            playsInline
            preload="metadata"
            className="interior-video-player"
            controlsList="nodownload"
            onError={handleVideoError}
            onLoadedMetadata={handleVideoLoad}
            onLoadStart={handleLoadStart}
            onCanPlay={handleCanPlay}
            onWaiting={handleWaiting}
            onPlaying={handlePlaying}
          >
            <source src={fullVideoUrl} type="video/mp4" />
            <source src={fullVideoUrl} type="video/webm" />
            <source src={fullVideoUrl} type="video/ogg" />
            Your browser does not support the video tag.
          </video>
        </>
      )}
    </div>
  );
};

export default InteriorVideoPlayer;